<template>
	<div>
		<v-dialog v-model="dialog_filter_items" no-click-animation persistent scrollable content-class="select_field_dialog" lazy transition="dialog-bottom-transition">
	        <v-card>
	        	<!-- <v-card-title noshadow class="dialog_searchbox">
	        		<v-subheader full-width>{{title}}</v-subheader>
	        	</v-card-title>
	        	
	        	<v-divider></v-divider> -->

		        <v-card-text full-height nopadding>

			        <v-list nopadding>
			        	<v-list-tile v-for="(item, index) in filterItems" :key="index" @click="setFilter(item.filterItemId)">

				            <v-list-tile-content>
				              <v-list-tile-title>{{item.name}}</v-list-tile-title>
				            </v-list-tile-content>

				            <v-list-tile-action>
						        <v-icon v-if="item.filterItemId == selectedFilterItemId">radio_button_checked</v-icon>
						        <v-icon v-else>radio_button_unchecked</v-icon>
				            </v-list-tile-action>
			        	</v-list-tile>
			        </v-list>
		        </v-card-text>
		       <!--  <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">close</v-btn>
		        </v-card-actions> -->
		    </v-card>


	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['title', 'filterItems', 'setFilter', 'selectedFilterItemId'],
		data(){
			return{
				dialog_filter_items:false,
			}
		},
		methods:{
			openDialogWeb: function () {
				this.dialog_filter_items = true;
			},
			closeDialogWeb: function () {
				this.dialog_filter_items = false;
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/dialog_filter_items.vue